export default () => ({
	filter: {
		where: null
	},
	list: {
		templatesList: []
	}
})
